import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent {
  @Input()
  title: string;
  @Input()
  text: string;
  @Input()
  okLabel: string = 'Ok';
  @Output()
  close = new EventEmitter<any>();
}
